export default __webpack_public_path__ + "static/media/BD.8a1b72a6.svg";